<template>
    <div class="header-container" :class="{ 'header-container-mobile': false && isMobile }">
      <div class="header-main">
        <router-link
          to="/"
          @click.prevent="navigateHome()"
          :title="$t('header.home')"
        >
          <img class="header-logo" :src="logoUrl" alt="logo" />
        </router-link>

        <router-link
          v-if="showResultsNavigationButton"
          to="/search"
          class="header-button"
          @click.prevent="navigateResults()"
        >{{ $t('header.close') }}</router-link>

        <div v-if="title" class="vr"></div>

        <div v-if="title" id="appearance-title" class="appearance-title" v-html="parseDOM(title)"></div>

        <div v-if="showHeaderMainSearchBar" class="header-searchbar">
          <search-bar></search-bar>
        </div>

        <div class="flex-grow-1"></div>

        <router-link
          to="/shop/basket"
          class="header-button"
          v-if="hasShopModule"
        >
          <span v-if="basketItemCount > 0" class="header-basket-count">{{ basketItemCount }}</span>
          <img src="/img/icons/cart.png" class="header-icon"/>
        </router-link>

        <div v-if="clientSettings.enableInfotext && clientSettings.infotext" class="header-button header-submenu-trigger">
          <img src="/img/icons/information.png" class="header-icon" alt="information" />
          <div class="header-submenu-container">
            <div class="header-submenu-scroll">
              <rich-text-editor class="informationtext" :content="clientSettings.infotext" :readonly="true" />
            </div>
          </div>
        </div>

        <router-link
          to="/bookshelf"
          class="header-button"
          v-if="showNavigationToBookshelf"
          :title="capitalize($t('bookshelf.bookshelves'))"
        >
          <img src="/img/icons/bookshelf.png" class="header-icon" :alt="capitalize($t('bookshelf.bookshelves'))"/>
        </router-link>

        <div class="header-button header-submenu-trigger">
          <img src="/img/icons/menu.png" class="header-icon" alt="menu" />
          <div class="header-submenu-container">
            <usermenu v-if="$store.state.initialised"></usermenu>
          </div>
        </div>
      </div>
      <div v-if="false && isMobile" class="header-search">
        <search-bar :flex="true"></search-bar>
      </div>
    </div>
</template>
<script>
import SearchBar from '@/components/search/SearchBar'
import UserMenu from '@/components/UserMenu'
import RichTextEditor from '@/components/form-elements/RichTextEditor'
import { mapState, mapGetters } from 'vuex'
import { Events } from '@/events'
import domparser from '@/mixins/domparser'
import ScreenSizeMixin from '@/mixins/screensize'

export default {
  name: 'header',
  mixins: [domparser, ScreenSizeMixin],
  computed: {
    ...mapState({
      booksInBasket: state => state.shop.basket.books
    }),
    ...mapGetters('searchStore/searchModules', {
      hasShopModule: 'hasModuleWithShopAction'
    }),
    logoUrl () {
      const clientLogoUrl = this.$store.getters['settings/getClientLogo']
      return clientLogoUrl || '/img/hl-logo-full.svg'
    },
    title () {
      if (!this.$store.state.reader) return null
      return this.$store.getters['reader/getAppearanceTitle']
    },
    basketItemCount () {
      return this.booksInBasket.length
    },
    showNavigationToBookshelf () {
      return this.$store.getters.userHasUserRole
    },
    showHeaderMainSearchBar () {
      return this.$route.name === 'results' && !this.isMobile
    },
    showHeaderMobileSearchBar () {
      return this.$route.name === 'results' && this.isMobile
    },
    showResultsNavigationButton () {
      return this.$route.name === 'reader'
    },
    clientSettings () {
      return this.$store.getters['settings/getClientSettings']
    }
  },
  methods: {
    navigateHome () {
      if (this.$route.name === 'home') {
        Events.$emit('libraryReset')
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    navigateResults () {
      this.$router.push({ name: 'search' })
    }
  },
  components: {
    'search-bar': SearchBar,
    usermenu: UserMenu,
    'rich-text-editor': RichTextEditor
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/css/_constants";
  @import '../assets/css/mixins/screenSize';

  .header-container {
    display: flex;
    flex-flow: column;
    padding: 14px;
    height: $header_height;
    z-index: 100;
    background-color: white;

    &-mobile {
      height: 100px;
    }

    .header-main {
      display: flex;
      flex-direction: row;
      flex-flow: row nowrap;
      align-items: center;
    }

    .header-logo {
      margin: 0 1rem 0 0;
      height: 26px;
    }

    .header-button {
      display: inline-block;
      height: 40px;
      padding: 10px;
      text-decoration: none;
      cursor: pointer;
      font-weight: bold;
      vertical-align: top;
      color: black;
      flex-shrink: 0;

      img, svg {
        margin: 10px;
        height: 20px;

        &.header-icon {
          margin: 0;
        }
      }

      &.router-link-exact-active {
        border-bottom: 4px solid $grey_dark;
      }

      &:hover {
        border-bottom: 4px solid $main_light;
      }

      &.header-submenu-trigger {
        &:hover {
          border-bottom: none;

          .header-submenu-container {
            display: block;
          }
        }
      }
    }

    .appearance-title {
      font-weight: bold;
      width: calc(100% - 260px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      @include phone {
        display: none;
      }
    }

    .vr {
      height:22px;
      margin: 8px;
      border-left: 2px solid $grey_middle;
      display: inline-block;
      vertical-align: top;
    }
  }

  .header-submenu-container {
    display: none;
    position: absolute;
    top: calc(100% - 2px);
    right: 0;
    background-color: white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    z-index: 1;
    font-weight: normal;

    .header-submenu-group {
      background-color: white;

      &:not(:last-child) {
        margin-bottom: 10px;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
      }

      .header-submenu-item {
        background: none;
        border: none;
        width: 100%;
        font-family: $font;
        font-size: $font_size;
        padding: 9px 13px;
        cursor: pointer;
        display: inline-block;
        text-decoration: none;
        color: black;
        text-align: left;
        font-weight: normal;
        white-space: nowrap;

        &:hover {
          background-color: $grey_light;
        }
      }
    }
  }

  .header-basket-count {
    position: absolute;
    right: 2px;
    top: 2px;
    padding: 0px 4px;
    border-radius: 12px;
    z-index: 1;
    font-weight: normal;
    background: $red;
    color: white;
  }

  .header-searchbar {
    flex-grow: 0;
    flex-shrink: 0;
    margin-left: 10px;
  }

  .informationtext {
    width: $informationtext_width;
  }

  .header-submenu-scroll {
    width: 100%;
    max-height: calc(100vh - 100px);
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
